import React, { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

/**
 * The OAuth client processes the callback inside AuthProvider's init(), so this
 * page only waits for the session and then hands over.
 */
export default function Callback() {
  const { session, loading, error } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (loading) return;
    // A callback with no session means the exchange failed (bad state, expired
    // request, or a redirect to the wrong origin). Return to login rather than
    // leaving the user on a spinner forever.
    navigate(session ? '/' : '/login', { replace: true });
  }, [loading, session, navigate]);

  return (
    <div className="app-container">
      <header className="navbar">
        <div className="navbar-logo">Follower</div>
      </header>
      <main className="main-container">
        {error ? (
          <div className="notice notice-error" role="alert">
            {error}
          </div>
        ) : (
          <p className="status" role="status">
            Finishing sign-in…
          </p>
        )}
        <Link className="button-link" to="/login">
          Back to sign-in
        </Link>
      </main>
    </div>
  );
}
